import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listSort'
})
export class ListSortPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
